"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var moment_1 = __importDefault(require("moment"));

var numeral_1 = __importDefault(require("numeral"));

var recharts_1 = require("recharts");

var styled_1 = require("./styled");
/**
 * Price Chart component
 *
 * Price Chart for historical coin data `recharts` http://recharts.org/en-US/api/PieChart
 *
 */


var PriceChart = function PriceChart(_ref) {
  var _ref$timeFormat = _ref.timeFormat,
      timeFormat = _ref$timeFormat === void 0 ? 'ddd Do HH:MM' : _ref$timeFormat,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data;
  var axisStyle = {
    fill: "#989ca7",
    fontSize: "13px",
    fontWeight: "bold"
  };
  return react_1["default"].createElement(recharts_1.ResponsiveContainer, {
    debounce: 1
  }, react_1["default"].createElement(recharts_1.AreaChart, {
    data: data,
    margin: {
      top: 10,
      left: 0,
      bottom: 46
    }
  }, react_1["default"].createElement(recharts_1.YAxis, {
    interval: "preserveStart",
    tick: axisStyle,
    tickFormatter: function tickFormatter(tick) {
      return numeral_1["default"](tick).format("$0,0");
    },
    width: 44
  }), react_1["default"].createElement(recharts_1.XAxis, {
    dataKey: "time",
    minTickGap: 70,
    tick: axisStyle,
    tickFormatter: function tickFormatter(tick) {
      return moment_1["default"].unix(tick).format(timeFormat);
    },
    tickMargin: 16,
    tickSize: 0
  }), react_1["default"].createElement(recharts_1.CartesianGrid, {
    stroke: "rgba(180, 180, 180, 0.4)",
    vertical: false
  }), react_1["default"].createElement(recharts_1.Tooltip // eslint-disable-next-line @typescript-eslint/no-explicit-any
  , {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    content: function content() {
      var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var payload = res.payload && res.payload.length > 0 && res.payload[0] ? res.payload[0].payload : {
        open: '',
        time: 0
      };
      var price = react_1["default"].createElement("span", null, numeral_1["default"](payload.open).format('$0,0.00'));
      var time = react_1["default"].createElement("span", null, moment_1["default"].unix(payload.time).format(timeFormat));
      return react_1["default"].createElement("div", null, react_1["default"].createElement(styled_1.Label, null, react_1["default"].createElement("p", null, time, ":"), react_1["default"].createElement("p", {
        className: 'price-label'
      }, price)));
    },
    cursor: {
      stroke: '#6B717E',
      strokeWidth: 1
    }
  }), react_1["default"].createElement(recharts_1.Area, {
    type: "monotone",
    dataKey: "open",
    activeDot: {
      fill: "#FFFFFF",
      stroke: '#6B717E',
      strokeWidth: 3,
      r: 6
    },
    fillOpacity: 0.3,
    fill: "#0AC18E",
    stroke: "#0AC18E",
    strokeWidth: 2
  })));
};

exports["default"] = PriceChart;